import React from 'react';
import Hero from '../../components/pages/Privacy/Hero/Hero';
import Content from '../../components/pages/Privacy/Content/Content';

const Privacy = () => {
  return (
    <div>
      <Hero />
      <Content />
    </div>
  );
};

export default Privacy;
